/**
 * 定数定義
 *
 * アプリケーション全体で使用する定数
 */

import type { PieceType } from '@/types/game';

/**
 * 駒表示名マッピング
 */
export const PIECE_NAMES: Record<PieceType, string> = {
  SHI: 'し',
  OU: '王',
  KAKU: '角',
  HI: '飛',
  KIN: '金',
  GIN: '銀',
  UMA: '馬',
  KYOU: '香',
};

/**
 * 駒カラーマッピング（Tailwind CSS）
 */
export const PIECE_COLORS: Record<PieceType, string> = {
  SHI: 'bg-goita-shi',
  OU: 'bg-goita-ou',
  KAKU: 'bg-goita-kaku',
  HI: 'bg-goita-hi',
  KIN: 'bg-goita-kin',
  GIN: 'bg-goita-gin',
  UMA: 'bg-goita-uma',
  KYOU: 'bg-goita-kou',
};

/**
 * アクションタイプ表示名
 */
export const ACTION_NAMES = {
  ATTACK: '攻め',
  RECEIVE: '受け',
  PASS: 'なし',
  HIDDEN_PLACE: '伏せ',
};

/**
 * ゲームフェーズ表示名
 */
export const PHASE_NAMES = {
  HIDDEN_PLACEMENT: '伏せ駒配置フェーズ',
  MAIN_PLAY: 'メインプレイフェーズ',
  ROUND_END: 'ラウンド終了',
  GAME_END: 'ゲーム終了',
};

/**
 * デフォルト設定値
 */
export const DEFAULT_CONFIG = {
  WINNING_POINTS: 150,
  AI_LEVEL: 'intermediate' as const,
  ENABLE_SPECIAL_RULES: true,
};

/**
 * API エンドポイント
 */
export const API_ENDPOINTS = {
  HEALTH: '/health',
  GAMES: '/games',
  GAME_ACTIONS: (gameId: string) => `/games/${gameId}/actions`,
};
